module.exports = __webpack_public_path__ + "static/img/Bachelor_010253.02b5e38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010253.jpg
// module id = 129
// module chunks = 0